import { ThemeEnum } from '@app/common';
import { DefaultTheme } from 'styled-components';
import { color } from '../colors';

export const createTextfield = (t: ThemeEnum) => {
    const textfield: DefaultTheme['textfield'] = {
        base: {
            open: {
                background: color[t].light.gray,
                color: color[t].base.text,
            },
        },
        hover: {
            open: {
                background: color[t].darken.gray,
                color: color[t].base.white,
            },
        },
    };
    return textfield;
};
